$(document).ready(function () {
    createBetterPagination();
});

document.addEventListener('ShoptetDOMContentLoaded', function () {
    createBetterPagination();
});



function createBetterPagination() {
    const $pagination = $('.pagination__list');
    if (!$pagination.length) return;

    const currentPage = parseInt($('.pagination__currentPage').text());
    if (!currentPage) return;

    function getPageFromHref(href) {
        if (!href) return NaN;
        const match = href.match(/strana-?(\d+)\//);
        return match ? parseInt(match[1]) : NaN;
    }

    const prevLink = $('.pagination__link--prev').attr('href');
    const nextLink = $('.pagination__link--next').attr('href');

    const pagePrefix = 'strana-';

    const explicitLastText = parseInt($('.pagination__link--last').text()) || 0;
    const explicitLastHref = getPageFromHref($('.pagination__link--last').attr('href')) || 0;

    let numericLinksMax = 0;
    $('.pagination__link').each(function () {
        const page = parseInt($(this).text());
        if (!isNaN(page) && page > numericLinksMax) {
            numericLinksMax = page;
        }
    });

    const lastPage = Math.max(currentPage, explicitLastText, explicitLastHref, numericLinksMax);
    if (!lastPage) return;

    // Základ URL bereme z aktuální cesty, aby se vždy zachoval segment kategorie.
    const lastHref = $('.pagination__link--last').attr('href') || '';
    const sampleUrl = nextLink || lastHref || (window.location.pathname + window.location.search);

    let query = '';
    const queryIndex = sampleUrl.indexOf('?');
    if (queryIndex !== -1) {
        query = sampleUrl.slice(queryIndex);
    }
    if (!query && window.location.search) {
        query = window.location.search;
    }

    let cleanPath = (window.location.pathname || '/').replace(/\/strana-?\d+\/?$/, '/');
    if (!cleanPath.endsWith('/')) {
        cleanPath += '/';
    }

    // 🔥 mapa existujících odkazů
    let linksMap = {};
    $('.pagination__link').each(function () {
        const page = parseInt($(this).text());
        const href = $(this).attr('href');
        if (!isNaN(page) && href && href !== '#') {
            linksMap[page] = href;
        }
    });

    function getPageUrl(page) {
        if (linksMap[page]) return linksMap[page];

        if (page === 1) return cleanPath + query;

        return `${cleanPath}${pagePrefix}${page}/${query}`;
    }

    let pages = [];
    if (currentPage <= 2) {
        pages = [1, 2, 3];
    } else if (currentPage >= lastPage - 1) {
        pages = [lastPage - 2, lastPage - 1, lastPage];
    } else {
        pages = [currentPage, currentPage + 1, currentPage + 2];
    }

    pages = pages.filter(p => p > 0 && p <= lastPage);

    let html = '';

    if (prevLink) {
        html += `
        <li class="prev">
            <a class="pagination__link pagination__link--prev btn btn-secondary" href="${prevLink}">
      
            </a>
        </li>`;
    }

    if (pages[0] > 1) {
        html += `<li><a class="pagination__link" href="${getPageUrl(1)}">1</a></li>`;
        if (pages[0] > 2) html += `<li class="pagination__dots">...</li>`;
    }

    pages.forEach(page => {
        if (page === currentPage) {
            html += `
            <li>
                <strong class="pagination__currentPage" aria-current="page">${page}</strong>
            </li>`;
        } else {
            html += `
            <li>
                <a class="pagination__link" href="${getPageUrl(page)}">${page}</a>
            </li>`;
        }
    });

    if (pages[pages.length - 1] < lastPage) {
        if (pages[pages.length - 1] < lastPage - 1) {
            html += `<li class="pagination__dots">...</li>`;
        }
        html += `
        <li>
            <a class="pagination__link pagination__link--last" href="${getPageUrl(lastPage)}">
                ${lastPage}
            </a>
        </li>`;
    }

    if (nextLink) {
        html += `
        <li class="next">
            <a class="pagination__link pagination__link--next btn btn-secondary" href="${nextLink}">
          
            </a>
        </li>`;
    }

    $pagination.html(html);
}